export enum CacheOptions {
	CACHED = true as any,
	NOT_CACHED = false as any
}

